import React, { Component } from 'react';

const CDN = 'https://baryon.million-edge.online/public/html/images/leaderboard';
const BANNER = 'https://baryon.million-edge.online/public/html/cms/banner20251231071434203_imageFileSharedModel_D.jpg';

// ── data ─────────────────────────────────────────────────────
function mask(name) {
  return name.split('').map((c, i) => (i % 2 === 0 ? c : '*')).join('');
}
const NAMES = ['suwan7', 'peemai9', 'Poopom', 'nongpak', 'kkete2u', 'xkuhe1x', 'xxGOnGz', 'bOoNek12', 'kaPo3s3', 'nnnxgnigoD',
  'thana01', 'minkz88', 'Paween5', 'sukjai9', 'lucky77', 'rattana', 'pitchak', 'natcha2', 'warut3x', 'ekkapon'];
const TURNOVER = [323506472, 318222497, 316665406, 313485344, 306815532, 303821692, 302757139, 289681692, 289226828, 275510121,
  241332100, 225810400, 198743200, 185432100, 172300900, 158200400, 145900300, 132400100, 119800200, 108700500];
const PRIZE_NAMES = [
  'นาฬิกา Rolex GMT-Master II',
  'กระเป๋าเดินทาง Louis Vuitton รุ่น Horizon 55',
  'กระเป๋ารุ่น Keepall Bandoulière 50',
  'MacBook Pro 14-Inch (M5 Pro, 32GB, 1TB)',
  'มอเตอร์ไซต์ไฟฟ้า NQi Sport',
  'iPhone 17 Pro Max 1TB',
  'iPad Pro 13-Inch (Wifi, 256GB)',
  'สร้อยคอ Dio(r)evolution Choker',
  'Apple Watch Ultra 2 (49mm)',
  'Samsung Galaxy Z Fold 7',
];

const players = NAMES.map((n, i) => ({
  rank: i + 1,
  name: mask(n),
  turnover: TURNOVER[i].toLocaleString('en-US', { minimumFractionDigits: 2 }),
}));

const prizes = PRIZE_NAMES.map((p, i) => ({ rank: i + 1, name: p }));

const FEATURES = [
  { img: `${CDN}/realtime-leaderboard-icon.png`,             title: 'ลีดเดอร์บอร์ดแบบเรียลไทม์',      desc: 'ลีดเดอร์บอร์ด PK8 ช่วยให้ผู้เล่นสามารถวัดประสิทธิภาพและตรวจสอบอันดับตัวเองในแบบเรียลไทม์' },
  { img: `${CDN}/lucrative-prizes-icon.png`,                 title: 'รางวัลอันทรงคุณค่า',              desc: 'ยิ่งคุณก้าวขึ้นไปสู่อันดับที่สูงขึ้นเท่าไหร่ คุณก็จะได้รับของรางวัลและรางวัลอันทรงคุณค่ามากยิ่งขึ้นตามลำดับของคุณ!' },
  { img: `${CDN}/fair-play-challenges.png`,                  title: 'ความท้าทายในการเล่นอย่างยุติธรรม', desc: 'กำหนดตัวเองและคนอื่นๆ ในระดับสมาชิกเดียวกันเพื่อเป็นหนึ่งในสมาชิก 10 อันดับแรกบนกระดานของผู้เล่นรายเดือน' },
  { img: `${CDN}/great-selection-of-game-categories-icon.png`, title: 'มีหมวดหมู่เกมให้เลือกมากมาย', desc: 'ผู้เล่นสามารถก้าวขึ้นไปได้ใน 4 หมวดหมู่ที่มีเกม กีฬา คาสิโนสด สล็อต ตกปลา และยอดเสียอีกด้วย' },
];

const TIERS = [
  { key: 'normal',   label: 'NORMAL',   coin: `${CDN}/coin-normal.png`,   color: '#3a8fe0' },
  { key: 'bronze',   label: 'BRONZE',   coin: `${CDN}/coin-bronze.png`,   color: '#cd7f32' },
  { key: 'silver',   label: 'SILVER',   coin: `${CDN}/coin-silver.png`,   color: '#9eaab7' },
  { key: 'gold',     label: 'GOLD',     coin: `${CDN}/coin-gold.png`,     color: '#c9a227' },
  { key: 'platinum', label: 'PLATINUM', coin: `${CDN}/coin-platinum.png`, color: '#8aafc5' },
  { key: 'diamond',  label: 'DIAMOND',  coin: `${CDN}/coin-diamond.png`,  color: '#f77f00' },
];

const GAME_TABS = ['กีฬา', 'คาสิโน', 'สล็อต', 'อื่นๆ'];
const MAIN_TABS = ['เกี่ยวกับ', 'ลำดับของฉัน', 'รางวัล'];

// ── sub-components ───────────────────────────────────────────
function RankBadge({ rank }) {
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: 32, height: 32, borderRadius: 6, flexShrink: 0,
      background: rank <= 3 ? '#f77f00' : '#e8eaf0',
      color: rank <= 3 ? '#fff' : '#888',
      fontWeight: 800, fontSize: 14,
    }}>{rank}</div>
  );
}

function LeaderRow({ rank, name, value }) {
  const top3 = rank <= 3;
  return (
    <tr style={{ background: top3 ? '#003087' : (rank % 2 === 0 ? '#f9fafc' : '#fff'), borderTop: '1px solid #eaecf4' }}>
      <td style={{ padding: '12px 16px', width: 80 }}><RankBadge rank={rank} /></td>
      <td style={{ padding: '12px 16px', color: top3 ? '#fff' : '#333', fontSize: 14, fontWeight: top3 ? 600 : 400 }}>{name}</td>
      <td style={{ padding: '12px 16px', textAlign: 'right', paddingRight: 20, color: top3 ? '#fff' : '#333', fontSize: 14, fontWeight: top3 ? 600 : 400 }}>{value}</td>
    </tr>
  );
}

function PrizeRow({ rank, name }) {
  const top3 = rank <= 3;
  return (
    <tr style={{ background: top3 ? '#003087' : (rank % 2 === 0 ? '#f9fafc' : '#fff'), borderTop: '1px solid #eaecf4' }}>
      <td style={{ padding: '12px 16px', width: 80 }}><RankBadge rank={rank} /></td>
      <td style={{ padding: '12px 16px', color: top3 ? '#fff' : '#333', fontSize: 14, fontWeight: top3 ? 600 : 400 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src={`${CDN}/${rank <= 3 ? 'rewards-gift' : 'small-rewards-gift'}.png`} alt="" style={{ width: rank <= 3 ? 36 : 24, height: rank <= 3 ? 36 : 24, objectFit: 'contain' }} />
          {name}
        </div>
      </td>
      <td style={{ padding: '12px 16px', textAlign: 'right', paddingRight: 20, color: top3 ? '#aac4f0' : '#999', fontSize: 13 }}>ดูรายละเอียด</td>
    </tr>
  );
}

// ── main component ───────────────────────────────────────────
class LeaderboardPage extends Component {
  constructor(props) {
    super(props);
    this.state = { mainTab: 'เกี่ยวกับ', gameTab: 'กีฬา', tier: 'diamond' };
  }

  renderTierChips() {
    const { tier } = this.state;
    return (
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 16, alignItems: 'center' }}>
        {TIERS.map(t => {
          const active = tier === t.key;
          return (
            <button key={t.key} onClick={() => this.setState({ tier: t.key })} style={{
              display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontFamily: 'inherit',
              border: active ? `2px solid ${t.color}` : '2px solid #e0e3ef',
              borderRadius: 20, padding: '4px 12px 4px 6px',
              background: active ? t.color : '#fff',
              color: active ? '#fff' : '#888',
              fontWeight: 700, fontSize: 12, transition: 'all .15s',
            }}>
              <img src={t.coin} alt={t.label} style={{ width: 22, height: 22, objectFit: 'contain' }} />
              {t.label}
            </button>
          );
        })}
      </div>
    );
  }

  renderGameTabs() {
    const { gameTab } = this.state;
    return (
      <div style={{ display: 'flex', gap: 0, background: '#fff', border: '1px solid #e0e3ef', borderRadius: 8, overflow: 'hidden', maxWidth: 360, marginBottom: 14 }}>
        {GAME_TABS.map(t => (
          <button key={t} onClick={() => this.setState({ gameTab: t })} style={{
            flex: 1, border: 'none', cursor: 'pointer', padding: '10px 0', fontSize: 13,
            background: gameTab === t ? '#f77f00' : 'transparent',
            color: gameTab === t ? '#fff' : '#666',
            fontWeight: gameTab === t ? 700 : 400,
            fontFamily: 'inherit', transition: 'all .15s',
          }}>{t}</button>
        ))}
      </div>
    );
  }

  renderTable(rows) {
    return (
      <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #dde1ed', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f0f2f8' }}>
              <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 13, color: '#666', fontWeight: 600, width: 80 }}>การจัดอันดับ</th>
              <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 13, color: '#666', fontWeight: 600 }}>ชื่อผู้ใช้</th>
              <th style={{ padding: '12px 16px', textAlign: 'right', paddingRight: 20, fontSize: 13, color: '#666', fontWeight: 600 }}>ยอดเทิร์นโอเวอร์</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  }

  renderPrizeTable(rows) {
    return (
      <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #dde1ed', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f0f2f8' }}>
              <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 13, color: '#666', fontWeight: 600, width: 80 }}>ลำดับ</th>
              <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 13, color: '#666', fontWeight: 600 }}>ชื่อรางวัล</th>
              <th style={{ padding: '12px 16px', textAlign: 'right', paddingRight: 20, fontSize: 13, color: '#666', fontWeight: 600 }}>ข้อมูลรางวัล</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  }

  // ════════════ MOBILE (แยกจาก desktop) ════════════
  renderMobile() {
    const { mainTab } = this.state;
    const wrap = { padding: '0 14px' };

    return (
      <div style={{ background: '#f5f6fa', minHeight: '100vh', fontFamily: 'Noto Sans Thai, sans-serif', color: '#222' }}>
        {/* Hero */}
        <div style={{ position: 'relative', background: '#001a4d', overflow: 'hidden' }}>
          <img src={BANNER} alt="Leaderboard" style={{ width: '100%', display: 'block', maxHeight: 190, objectFit: 'cover', objectPosition: 'center' }} />
          <div style={{ position: 'absolute', top: 0, left: 0, padding: '20px 18px' }}>
            <div style={{ fontSize: 18, fontWeight: 900, color: '#fff', lineHeight: 1.35, textShadow: '0 2px 8px rgba(0,0,0,0.5)' }}>
              ลีดเดอร์บอร์ด<br />
              <span style={{ fontSize: 13, fontWeight: 700 }}>ก้าวขึ้นมาเป็นผู้นำ รางวัลใหญ่</span><br />
              <span style={{ fontSize: 12, fontWeight: 500, opacity: 0.9 }}>อาจเป็นของคุณ</span>
            </div>
          </div>
        </div>

        {/* Main tabs (เต็มกว้าง) */}
        <div style={{ background: '#fff', borderBottom: '1px solid #e8eaf0', display: 'flex', position: 'sticky', top: 0, zIndex: 5 }}>
          {MAIN_TABS.map(t => {
            const active = mainTab === t;
            return (
              <button key={t} onClick={() => this.setState({ mainTab: t })} style={{
                flex: 1, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 14, fontWeight: 600,
                padding: '13px 4px', background: 'none', color: active ? '#f77f00' : '#666',
                borderBottom: active ? '3px solid #f77f00' : '3px solid transparent',
              }}>{t}</button>
            );
          })}
        </div>

        {/* เกี่ยวกับ */}
        {mainTab === 'เกี่ยวกับ' && (
          <div style={{ ...wrap, paddingTop: 22, paddingBottom: 32 }}>
            <div style={{ fontSize: 17, fontWeight: 800, color: '#1a1a2e', marginBottom: 6 }}>ลีดเดอร์บอร์ด PK8 สุดพิเศษ</div>
            <div style={{ fontSize: 13, color: '#e07b00', marginBottom: 20, lineHeight: 1.7 }}>
              แสดงให้พวกเขาเห็นว่าคุณเจ๋งแค่ไหน! สมาชิก 10 อันดับแรกประจำเดือนจะได้รับคะแนนและรางวัลมากขึ้นตามระดับสมาชิก
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 12 }}>
              {FEATURES.map((f, i) => (
                <div key={i} style={{ background: '#fff', borderRadius: 12, padding: '16px 12px', textAlign: 'center', border: '1px solid #e8eaf0', boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}>
                  <img src={f.img} alt={f.title} style={{ width: '100%', height: 90, objectFit: 'contain', marginBottom: 10 }} />
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a2e', marginBottom: 6 }}>{f.title}</div>
                  <div style={{ fontSize: 11.5, color: '#888', lineHeight: 1.7 }}>{f.desc}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ลำดับของฉัน */}
        {mainTab === 'ลำดับของฉัน' && (
          <div style={{ ...wrap, paddingTop: 20, paddingBottom: 32 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e', marginBottom: 12 }}>อันดับของฉัน</div>
            {this.renderGameTabs()}
            {this.renderTierChips()}
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
              {this.renderTable(players.map(p => <LeaderRow key={p.rank} rank={p.rank} name={p.name} value={p.turnover} />))}
            </div>
          </div>
        )}

        {/* รางวัล */}
        {mainTab === 'รางวัล' && (
          <div style={{ ...wrap, paddingTop: 20, paddingBottom: 32 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e', marginBottom: 12 }}>รางวัล</div>
            {this.renderGameTabs()}
            {this.renderTierChips()}
            <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
              <select style={{ flex: 1, border: '1px solid #e0e3ef', borderRadius: 6, padding: '8px 10px', fontSize: 13, color: '#444', fontFamily: 'inherit', cursor: 'pointer', background: '#fff' }}>
                <option>พฤษภาคม</option><option>เมษายน</option><option>มีนาคม</option>
              </select>
              <select style={{ flex: 1, border: '1px solid #e0e3ef', borderRadius: 6, padding: '8px 10px', fontSize: 13, color: '#444', fontFamily: 'inherit', cursor: 'pointer', background: '#fff' }}>
                <option>2026</option><option>2025</option>
              </select>
            </div>
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
              {this.renderPrizeTable(prizes.map(p => <PrizeRow key={p.rank} rank={p.rank} name={p.name} />))}
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    // แยกหน้า mobile กับ desktop
    if (window.innerWidth <= 760) {
      return this.renderMobile();
    }

    const { mainTab } = this.state;
    const wrap = { maxWidth: 900, margin: '0 auto', padding: '0 20px' };

    return (
      <div style={{ background: '#f5f6fa', minHeight: '100vh', fontFamily: 'Noto Sans Thai, sans-serif', color: '#222' }}>

        {/* ── Hero Banner ── */}
        <div style={{ position: 'relative', background: '#001a4d', overflow: 'hidden' }}>
          <img src={BANNER} alt="Leaderboard Banner" style={{ width: '100%', display: 'block', maxHeight: 320, objectFit: 'cover', objectPosition: 'center' }} />
          <div style={{ position: 'absolute', top: 0, left: 0, padding: '36px 32px' }}>
            <div style={{ fontSize: 22, fontWeight: 900, color: '#fff', lineHeight: 1.3, textShadow: '0 2px 8px rgba(0,0,0,0.5)' }}>
              ลีดเดอร์บอร์ด<br />
              <span style={{ fontSize: 16, fontWeight: 700 }}>ก้าวขึ้นมาเป็นผู้นำกับเราางวัลใหญ่</span><br />
              <span style={{ fontSize: 14, fontWeight: 500, opacity: 0.9 }}>อาจเป็นของคุณ</span>
            </div>
          </div>
        </div>

        {/* ── Main Tabs ── */}
        <div style={{ background: '#fff', borderBottom: '1px solid #e8eaf0' }}>
          <div style={{ ...wrap, display: 'flex', gap: 0 }}>
            {MAIN_TABS.map(t => {
              const active = mainTab === t;
              return (
                <button key={t} onClick={() => this.setState({ mainTab: t })} style={{
                  border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 14, fontWeight: 600,
                  padding: '14px 24px', background: 'none',
                  color: active ? '#f77f00' : '#666',
                  borderBottom: active ? '3px solid #f77f00' : '3px solid transparent',
                  transition: 'all .15s',
                }}>
                  {active
                    ? <span style={{ background: '#f77f00', color: '#fff', borderRadius: 20, padding: '6px 18px', fontSize: 13 }}>{t}</span>
                    : t}
                </button>
              );
            })}
          </div>
        </div>

        {/* ══════════════════════════════
            TAB: เกี่ยวกับ
        ══════════════════════════════ */}
        {mainTab === 'เกี่ยวกับ' && (
          <div style={{ ...wrap, paddingTop: 28, paddingBottom: 40 }}>
            <div style={{ fontSize: 18, fontWeight: 800, color: '#1a1a2e', marginBottom: 6 }}>ลีดเดอร์บอร์ด PK8 สุดพิเศษ</div>
            <div style={{ fontSize: 13, color: '#e07b00', marginBottom: 24, lineHeight: 1.7 }}>
              แสดงให้พวกเขาเห็นว่า คุณเจ๋งแค่ไหน! สมาชิก 10 อันดับแรกในตารางลีดเดอร์บอร์ดประจำเดือนจะได้รับคะแนนและรางวัลมากขึ้นตามระดับสมาชิก
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(190px,1fr))', gap: 16 }}>
              {FEATURES.map((f, i) => (
                <div key={i} style={{ background: '#fff', borderRadius: 12, padding: '20px 16px 18px', textAlign: 'center', border: '1px solid #e8eaf0', boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}>
                  <img src={f.img} alt={f.title} style={{ width: '100%', height: 130, objectFit: 'contain', marginBottom: 14 }} />
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 }}>{f.title}</div>
                  <div style={{ fontSize: 12, color: '#888', lineHeight: 1.75 }}>{f.desc}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ══════════════════════════════
            TAB: ลำดับของฉัน
        ══════════════════════════════ */}
        {mainTab === 'ลำดับของฉัน' && (
          <div style={{ ...wrap, paddingTop: 24, paddingBottom: 40 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#1a1a2e', marginBottom: 14 }}>อันดับของฉัน</div>
            {this.renderGameTabs()}
            {this.renderTierChips()}
            {this.renderTable(players.map(p => <LeaderRow key={p.rank} rank={p.rank} name={p.name} value={p.turnover} />))}
          </div>
        )}

        {/* ══════════════════════════════
            TAB: รางวัล
        ══════════════════════════════ */}
        {mainTab === 'รางวัล' && (
          <div style={{ ...wrap, paddingTop: 24, paddingBottom: 40 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#1a1a2e', marginBottom: 14 }}>รางวัล</div>
            {this.renderGameTabs()}
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 16, alignItems: 'center' }}>
              {TIERS.map(t => {
                const active = this.state.tier === t.key;
                return (
                  <button key={t.key} onClick={() => this.setState({ tier: t.key })} style={{
                    display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontFamily: 'inherit',
                    border: active ? `2px solid ${t.color}` : '2px solid #e0e3ef',
                    borderRadius: 20, padding: '4px 12px 4px 6px',
                    background: active ? t.color : '#fff',
                    color: active ? '#fff' : '#888',
                    fontWeight: 700, fontSize: 12, transition: 'all .15s',
                  }}>
                    <img src={t.coin} alt={t.label} style={{ width: 22, height: 22, objectFit: 'contain' }} />
                    {t.label}
                  </button>
                );
              })}
              <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                <select style={{ border: '1px solid #e0e3ef', borderRadius: 6, padding: '6px 10px', fontSize: 12, color: '#444', fontFamily: 'inherit', cursor: 'pointer', background: '#fff' }}>
                  <option>พฤษภาคม</option><option>เมษายน</option><option>มีนาคม</option>
                </select>
                <select style={{ border: '1px solid #e0e3ef', borderRadius: 6, padding: '6px 10px', fontSize: 12, color: '#444', fontFamily: 'inherit', cursor: 'pointer', background: '#fff' }}>
                  <option>2026</option><option>2025</option>
                </select>
              </div>
            </div>
            {this.renderPrizeTable(prizes.map(p => <PrizeRow key={p.rank} rank={p.rank} name={p.name} />))}
          </div>
        )}

      </div>
    );
  }
}

export default LeaderboardPage;
